<template>
  <div class="row iframe-container my-4">
    <div class="col-10 mx-auto">
      <h5 class="mb-2">
        {{ meeting.title }} by
        <router-link :to="'/speaker/' + meeting.speaker.url_key">{{ meeting.speaker.name }}</router-link>
      </h5>
      <p class="mb-2">
        {{ meeting.content }}
      </p>
      <vue-aspect-ratio ar="16:9" width="75%">
        <jwvideo :link="meeting.recording_path" :playerId="'video-player-1'"></jwvideo>
      </vue-aspect-ratio>
    </div>
  </div>
</template>
<script>
import VueAspectRatio from 'vue-aspect-ratio';
import video from '../partials/Video';

export default {
  components: {
    'vue-aspect-ratio': VueAspectRatio,
    jwvideo: video,
  },
  mounted() {
    let url = '/api/recordings/' + this.recording_id;
    this.$http.get(url).then(resp => {
      this.meeting = resp.data;
    });
  },
  data() {
    return {
      recording_id: this.$route.params.id,
      meeting: {},
    };
  },
};
</script>
